import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/components';
import { FC } from 'react';

export const UpdateDialog: FC<React.ComponentPropsWithoutRef<typeof Dialog>> = (
  props,
) => {
  const { ...restProps } = props;

  const handleOnReload = () => {
    window.location.reload();
  };

  //TODO: Check z-index for all app
  return (
    <Dialog {...restProps}>
      <DialogContent
        className="z-[1000000000] max-w-[250px]"
        overlayClassName="z-[100000000]"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>New version is available</DialogTitle>
          <DialogDescription>Reload this page to get update</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:space-x-0">
          <div className="flex w-full items-center justify-center">
            <Button
              aria-label="Reload page"
              onClick={handleOnReload}
            >
              Reload Page
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
